import { CardSubtitle } from "../../types/CoreComponents";

export const BasicAlertSubTitle: CardSubtitle[] = [{ text: "Print the basic message." }];

export const TitleWithTextSubTitle: CardSubtitle[] = [{ text: "Print the title with text." }];

export const InfoAlertSubTitle: CardSubtitle[] = [{ text: "Print the informational message." }];

export const WarningAlertSubTitle: CardSubtitle[] = [{ text: "Warning for imaginary files." }];

export const PikachuAlertSubTitle: CardSubtitle[] = [{ text: "catch the pokeball." }];

export const QuestionAlertSubTitle: CardSubtitle[] = [{ text: "Print the questionary and give answers." }];

export const UserNameAlertSubTitle: CardSubtitle[] = [{ text: "Print the basic sweet-alert" }];

export const SuccessMessageSubTitle: CardSubtitle[] = [{ text: "Print the success message." }];

export const DangerAlertSubTitle: CardSubtitle[] = [{ text: "Print the danger message." }];

export const WarningModeSubTitle: CardSubtitle[] = [{ text: "Print the warning message" }];

export const AutoCloseAlertSubTitle: CardSubtitle[] = [{ text: "A text message with an automatic timer" }];

export const MovieAlertSubTitle: CardSubtitle[] = [{ text: "Give the movie name & return value." }];
